/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCoinsCertified = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M4.292 5.58C4.01 5.83 4 5.975 4 6c0 .046.065.374.88.819.747.407 1.873.762 3.27.974l-.3 1.978C6.354 9.544 5.012 9.15 4 8.616V10c0 .046.065.373.88.819.747.407 1.873.762 3.27.974l-.3 1.978c-1.496-.228-2.838-.62-3.85-1.155V14c0 .046.065.373.88.819.747.407 1.873.762 3.27.974l-.3 1.978c-1.496-.227-2.838-.62-3.85-1.155V18c0 .046.065.374.88.819.747.407 1.873.762 3.27.974l-.3 1.978c-1.535-.233-2.909-.64-3.929-1.197C2.97 20.054 2 19.213 2 18V6c0-.803.437-1.448.965-1.916.53-.469 1.238-.846 2.027-1.142C6.578 2.347 8.702 2 11 2c2.297 0 4.422.347 6.008.942.79.296 1.498.673 2.027 1.142C19.563 4.552 20 5.197 20 6h-2c0-.026-.01-.17-.292-.42-.28-.248-.744-.518-1.402-.765C14.996 4.325 13.12 4 11 4s-3.997.324-5.306.815c-.658.247-1.121.517-1.402.766zM10 8h12v14H10zm2 2v10h8V10zm7 4h-6v-2h6zm0 4h-6v-2h6z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgCoinsCertified as CoinsCertified };
